import React, { useState, useRef } from "react";
import "../../css/Common.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function CommunicationTime({ value, onChange }) {
  const [tooltipStyle, setTooltipStyle] = useState({ display: "none" });
  const iconRef = useRef(null);

  const showTooltip = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipStyle({
        display: "block",
        top: `${rect.top + window.scrollY - 10}px`,
        left: `${rect.left + window.scrollX + rect.width + 20}px`,
      });
    }
  };

  const hideTooltip = () => {
    setTooltipStyle({ display: "none" });
  };

  const timeOptions = [
    {
      id: "Day time",
      label: "Day Time",
      description: "9 AM - 5 PM",
      icon: "☀️",
    },
    {
      id: "Evening",
      label: "Evening",
      description: "5 PM - 10 PM",
      icon: "🌅",
    },
    { id: "Any time", label: "Any Time", description: "24/7", icon: "🕐" },
  ];

  const handleTimeChange = (timeValue) => {
    onChange(timeValue);
  };
  return (
    <div className="common-form-group">
      <div className="common-form-field">
        <div className="common-label-container">
          <label className="common-label-with-icon">Communication Time</label>
          <FontAwesomeIcon
            ref={iconRef}
            icon={faCircleInfo}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            className="common-info-icon"
          />
        </div>
        <div className="control-tooltip" style={tooltipStyle}>
          When phishing simulation attempts should be sent to users
        </div>
      </div>

      <div className="common-form-group">
        <div className="common-radio-container">
          {timeOptions.map((option) => (
            <label key={option.id} className="common-radio-label">
              <input
                type="radio"
                id={`time-${option.id}`}
                name="communication-time"
                value={option.id}
                checked={value === option.id}
                onChange={() => handleTimeChange(option.id)}
                className="common-radio-input"
              />
              <div className="common-radio-content">
                <span className="common-radio-title">{option.label}</span>
                <span className="common-radio-description">
                  {option.description}
                </span>
              </div>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CommunicationTime;
